// extracted by mini-css-extract-plugin
module.exports = {"invalidInput":"ErrorLabel_invalidInput__1193i","yellowLabel":"ErrorLabel_yellowLabel__2Rpnq","greenLabel":"ErrorLabel_greenLabel__Y9wtl"};